var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.snackbar.active,"timeout":3000,"top":""},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"color":"error","text":""},on:{"click":_vm.clear}},'v-btn',attrs,false),[_vm._v("Закрыть")])]}}])},[_vm._v(" "+_vm._s(_vm.snackbar.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }